export const getProjectValue = (
  displayAmount: number | null | undefined
): number => {
  return displayAmount ?? 0;
};
